export enum UITypes {
    Bottom = 'bottom'
}